import EmailValidationSnackbar from './EmailValidationSnackbar';

export default EmailValidationSnackbar;
